import React from 'react';
import { TPropertiesOfPatchChangesForCategory } from 'types';
import OutsideFormInput from 'components/Input/OutsideFormInput';
import CronGenerator from 'components/CronGenerator/CronGenerator';
import Text from 'components/Text/Text';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import style from './Cron.module.scss';

interface IProps {
	changeActivationSchedule(value: string): void;
	changeDeactivationSchedule(value: string): void;
	activationSchedule: string;
	deactivationSchedule: string;
	selectedProperties: TPropertiesOfPatchChangesForCategory[];
	hasSchedulePriority: boolean;
}

export const Cron: React.FC<IProps> = ({
	changeActivationSchedule,
	changeDeactivationSchedule,
	activationSchedule,
	deactivationSchedule,
	selectedProperties,
	hasSchedulePriority,
}) => {
	return (
		<div className={style.container}>
			<div className={style.row}>
				{selectedProperties.includes('activation') && (
					<OutsideFormInput
						containerClassName={style.input}
						testId="ActivationScheduleInput"
						name="activationSchedule"
						label="activationScheduleLabel"
						placeholder="cronExpressionInputPlaceholder"
						maxLength={255}
						value={activationSchedule}
						onChange={changeActivationSchedule}
					/>
				)}
				{selectedProperties.includes('deactivation') && (
					<OutsideFormInput
						containerClassName={style.input}
						testId="DeactivationScheduleInput"
						name="deactivationSchedule"
						label="deactivationScheduleLabel"
						placeholder="cronExpressionInputPlaceholder"
						maxLength={255}
						value={deactivationSchedule}
						onChange={changeDeactivationSchedule}
					/>
				)}
			</div>
			<CronGenerator />
			{selectedProperties.some((selectedProperty) => ['activation', 'deactivation'].includes(selectedProperty)) &&
				hasSchedulePriority && (
					<div className={style.infoWrapper}>
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#circleInfoTransparent`} />
						</svg>
						<Text
							translationNameSpace="form"
							translationKey="warningCategorySchedule"
							theme="secondary"
							size="s"
							display="inline"
						/>
					</div>
				)}
		</div>
	);
};
